import React from 'react';
import { useHistory } from 'react-router-dom';
import Footer from '../components/global/footer';
import Header from '../components/global/header';
import screeningLogo from '../../assets/img/skrinig40.svg';


const NationalScreeningPage = ({ user }) => {
  const history = useHistory();

  const handleBooking = () => {
    const cityId = localStorage.getItem('cityId') || user?.city?.id || 1;
    history.push(`/city/${cityId}/list?screening_40_plus=true`);
  };
console.log('HeaderLogo render with city:', user);
  return (
    <div>
      <Header />
      <main className="about_main">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="national-screening-page">
                
                {/* Hero Section */}
                <div className="hero-section text-center mb-5">
                  <img 
                    src={screeningLogo} 
                    alt="Скринінг здоров'я 40+" 
                    className="screening-logo mb-4"
                  />
                  <h1 className="title">Скринінг здоров'я 40+</h1>
                  <p className="subtitle">Безкоштовна перевірка здоров'я для раннього виявлення захворювань</p>
                  <p className="hero-description">
                    З 2026 року всі громадяни України від 40 років можуть безоплатно пройти комплексне обстеження 
                    для виявлення ризику серцево-судинних захворювань і цукрового діабету 2 типу.
                  </p>
                  <p className="hero-description">
                    У сервісі «Лікарі 24/7» відображаються лише ті заклади-учасники програми, які використовують МІС «Каштан» та мають доступний час для онлайн-запису.
                  </p>
                  <div className="diya-card-notice">
                    <strong>⚠️ Важливо:</strong> Скринінг проводиться лише за кошти з Дія.Картки. 
                    <br/>Перед записом переконайтеся, що картка оформлена та активна
                    <br/><a className='' href="https://screening.moz.gov.ua/#dia" target="_blank" rel="noopener noreferrer">Детальніше на сайті МОЗ</a>
                  </div>
                  <button 
                    className="btn btn-primary btn-lg mt-3"
                    onClick={handleBooking}
                  >
                    Знайти доступний запис у закладах МІС «Каштан»
                  </button>
                </div>

                {/* About Section */}
                <section className="content-section mb-5">
                  <h2 className="section-title">Про програму скринінгу здоров'я</h2>
                  <div className="section-content">
                    <p>
                      Програма скринінгів здоров'я стартувала в Україні у 2026 році. Вона включає базові обстеження 
                      для раннього виявлення хвороб у щорічну перевірку здоров'я, зокрема ризику розвитку 
                      серцево-судинних захворювань та цукрового діабету 2 типу.
                    </p>
                    <p>
                      Скринінг проводиться у медичних закладах, які беруть участь у програмі – державних, комунальних 
                      та приватних. Ви можете обрати будь-який зручний заклад зі списку.
                    </p>
                    <a
                      className="official-program-link"
                      href="https://screening.moz.gov.ua/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Повний перелік закладів та актуальні умови — на офіційному сайті МОЗ ↗
                    </a>
                    <div className="highlight-box">
                      <strong>💳 Оплата:</strong> Скринінг проводиться за кошти з Дія.Картки.
                    </div>
                  </div>
                </section>

                {/* Target Audience */}
                <section className="content-section mb-5">
                  <h2 className="section-title">Для кого цей скринінг?</h2>
                  <p className="section-intro">
                    Програма призначена для всіх громадян України віком від 40 років. Раннє виявлення ризиків — це ваша можливість жити довше і здоровіше.
                  </p>
                  <div className="row mt-4">
                    <div className="col-md-4 mb-3">
                      <div className="target-card">
                        <h4>🩺 Подбайте про себе</h4>
                        <p>Після 40 років організм потребує більшої уваги. Регулярні перевірки допомагають виявити проблеми на ранніх стадіях, коли їх легше вирішити.</p>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="target-card">
                        <h4>❤️ Подаруйте здоров'я близьким</h4>
                        <p>Запишіть на скринінг своїх батьків чи рідних. Покажіть, що їхнє здоров'я для вас важливе — це найцінніший подарунок.</p>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="target-card">
                        <h4>👨‍👩‍👧‍👦 Підтримайте старше покоління</h4>
                        <p>Люди похилого віку часто відкладають візити до лікаря. Допоможіть їм записатися і пройти обстеження — це прояв справжньої турботи.</p>
                      </div>
                    </div>
                  </div>
                </section>

                {/* How to Process */}
                <section className="content-section mb-5">
                  <h2 className="section-title">Як пройти скринінг здоров'я?</h2>
                  <p className="section-intro">
                    Скринінг не потребує спеціальної підготовки.
                  </p>
                  <div className="steps-container">
                    <div className="step-item">
                      <div className="step-number">1</div>
                      <div className="step-content">
                        <h4>Оформіть Дія.Картку</h4>
                        <p>Переконайтеся, що у вас активна Дія.Картка – скринінг проводиться лише за кошти з неї. 
                        Оформити картку можна онлайн у застосунку Дія.</p>
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-number">2</div>
                      <div className="step-content">
                        <h4>Знайдіть лікаря та запишіться на скринінг</h4>
                        <p>Оберіть зручний медичний заклад зі списку учасників програми на нашій платформі. 
                        При виборі лікаря обов'язково оберіть фільтр "Скринінг здоров'я 40+".</p>
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-number">3</div>
                      <div className="step-content">
                        <h4>Пройдіть огляд та обстеження</h4>
                        <p>Лікар вимірює тиск, пульс, вагу, визначить ІМТ та окружність талії. Проведе опитування 
                        про спосіб життя та оцінить фактори ризику захворювань.</p>
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-number">4</div>
                      <div className="step-content">
                        <h4>Здайте лабораторні аналізи</h4>
                        <p>Лікар видасть направлення на необхідні аналізи крові та сечі.</p>
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-number">5</div>
                      <div className="step-content">
                        <h4>Отримайте персональні рекомендації</h4>
                        <p>Після отримання результатів лікар сформує для вас персональний план: щодо харчування, 
                        рухової активності, контролю за стресом та інших важливих аспектів здоров'я.</p>
                      </div>
                    </div>
                  </div>
                </section>

                {/* What's Included */}
                <section className="content-section mb-5">
                  <h2 className="section-title">Що входить у скринінг?</h2>
                  <p className="section-intro">
                    Перелік обстежень підбирається індивідуально відповідно до віку, статі та медичної історії, 
                    щоб врахувати саме ваші потреби у профілактиці.
                  </p>
                  <div className="row mt-4">
                    <div className="col-md-6 mb-4">
                      <div className="services-card">
                        <h4>Огляд і фізикальне дослідження</h4>
                        <ul>
                          <li>Вимірювання артеріального тиску (щонайменше двічі для виявлення гіпертензії)</li>
                          <li>Вимірювання частоти та ритму пульсу (для виявлення аритмій)</li>
                          <li>Антропометрія: маса тіла, зріст, окружність талії, індекс маси тіла (ІМТ)</li>
                          <li>За необхідності: домашній або добовий моніторинг тиску</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="services-card">
                        <h4>Оцінка факторів ризику</h4>
                        <ul>
                          <li>Опитування щодо куріння та вживання алкоголю</li>
                          <li>Оцінка рівня рухової активності</li>
                          <li>Збір інформації про сімейний анамнез</li>
                          <li>Виявлення симптомів, що можуть свідчити про ранні ознаки хвороб</li>
                          <li>Аналіз стану психічного здоров'я</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-4">
                      <div className="services-card">
                        <h4>Лабораторні дослідження</h4>
                        <p className="mb-3">Аналізи, що дозволяють виявити невідчутні зміни, які підвищують ризики небезпечних хвороб:</p>
                        <div className="row">
                          <div className="col-md-6">
                            <ul>
                              <li><strong>Ліпідограма</strong> – оцінка ризику атеросклерозу (звуження просвіту судин)</li>
                              <li><strong>Глікований гемоглобін (HbA1c)</strong> – середній рівень глюкози за 3 місяці, виявлення предіабету і діабету</li>
                            </ul>
                          </div>
                          <div className="col-md-6">
                            <ul>
                              <li><strong>Електроліти крові</strong> (натрій, калій) – оцінка функції нирок і серця</li>
                              <li><strong>Креатинін та eGFR</strong> – визначення стану нирок</li>
                              <li><strong>Альбумін/креатинін у сечі (ACR)</strong> – раннє виявлення ураження нирок</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-4">
                      <div className="services-card">
                        <h4>Консультація та персональний план</h4>
                        <p>Після всіх обстежень лікар разом із вами сформує персональний план покращення здоров'я:</p>
                        <ul>
                          <li>Рекомендації щодо харчування та раціону</li>
                          <li>План рухової активності</li>
                          <li>Поради з контролю за стресом</li>
                          <li>Допомога у відмові від куріння чи вживання алкоголю</li>
                          <li>Рекомендації щодо зниження маси тіла (за потреби)</li>
                          <li>У разі потреби – електронне направлення до профільного спеціаліста</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Why Important */}
                <section className="content-section mb-5">
                  <h2 className="section-title">🏥 Чому це важливо?</h2>
                  <p>Регулярні перевірки здоров'я допомагають:</p>
                  <div className="row mt-3">
                    <div className="col-md-6 mb-3">
                      <div className="benefit-item">
                        <i className="fas fa-check-circle text-success"></i>
                        <span>Виявити захворювання на ранній стадії, коли їх легше лікувати</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="benefit-item">
                        <i className="fas fa-check-circle text-success"></i>
                        <span>Запобігти розвитку серйозних ускладнень</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="benefit-item">
                        <i className="fas fa-check-circle text-success"></i>
                        <span>Знизити ризик інвалідності та смертності від хронічних захворювань</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="benefit-item">
                        <i className="fas fa-check-circle text-success"></i>
                        <span>Зекономити час і кошти на лікуванні в майбутньому</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="benefit-item">
                        <i className="fas fa-check-circle text-success"></i>
                        <span>Підвищити якість та тривалість життя</span>
                      </div>
                    </div>
                  </div>
                </section>

                {/* FAQ Section */}
                <section className="content-section mb-5">
                  <h2 className="section-title">Поширені запитання</h2>
                  
                  <div className="faq-item">
                    <h4>Хто може пройти скринінг здоров'я 40+?</h4>
                    <p>
                      Програма доступна для всіх громадян України віком від 40 років. Головна умова – 
                      наявність активної Дія.Картки, оскільки скринінг проводиться саме за кошти з неї.
                    </p>
                  </div>

                  <div className="faq-item">
                    <h4>Що таке Дія.Картка і як її оформити?</h4>
                    <p>
                      Дія.Картка – це єдина картка українця, яку можна оформити онлайн в застосунку Дія 
                      Переконайтеся, що ваша картка оформлена та активна перед записом на скринінг.
                    </p>
                  </div>

                  <div className="faq-item">
                    <h4>Як часто потрібно проходити скринінг?</h4>
                    <p>
                      Регулярні перевірки допомагають виявити захворювання на ранній стадії.
                    </p>
                  </div>

                  <div className="faq-item">
                    <h4>Це безкоштовно?</h4>
                    <p>
                      Так! Скринінг повністю безкоштовний для громадян України віком від 40 років. 
                      Оплата здійснюється за кошти з вашої Дія.Картки в рамках державної програми.
                    </p>
                  </div>

                  <div className="faq-item">
                    <h4>Де можна пройти скринінг?</h4>
                    <p>
                      Скринінг можна пройти в медичних закладах, які беруть участь у програмі – державних, 
                      комунальних та приватних. Оберіть зручний заклад на нашій платформі, використовуючи 
                      фільтр "Скринінг здоров'я 40+".
                    </p>
                  </div>

                  <div className="faq-item">
                    <h4>Скільки часу займає скринінг?</h4>
                    <p>
                      Спеціальної підготовки не потрібно.
                    </p>
                  </div>
                </section>

                {/* CTA Section */}
                <div className="cta-section text-center mt-5 mb-5">
                  <h3>💙 Подбайте про своє здоров'я вже сьогодні!</h3>
                  <p>Знайдіть зручний медичний заклад та запишіться на скринінг здоров'я</p>
                  <button 
                    className="btn btn-primary btn-lg"
                    onClick={handleBooking}
                  >
                    Знайти доступний запис у закладах МІС «Каштан»
                  </button>
                </div>

                {/* Useful Links */}
                <section className="content-section">
                  <h2 className="section-title">🔗 Корисні посилання</h2>
                  <ul className="links-list">
                    <li>
                      <a href="https://screening.moz.gov.ua/" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-external-link-alt"></i>
                        Скринінг здоровʼя 40+ на сайті МОЗ
                      </a>
                    </li>
                    <li>
                      <a href="https://nszu.gov.ua" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-external-link-alt"></i>
                        Національна служба здоров'я України
                      </a>
                    </li>
                    <li>
                      <a href="https://diia.gov.ua" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-external-link-alt"></i>
                        Застосунок Дія
                      </a>
                    </li>
                    <li>
                      <a href="https://moz.gov.ua" target="_blank" rel="noopener noreferrer">
                        <i className="fas fa-external-link-alt"></i>
                        Міністерство охорони здоров'я України
                      </a>
                    </li>
                  </ul>
                </section>

                <style>{`
                  .national-screening-page {
                    padding: 40px 0;
                  }

                  .hero-section {
                    padding: 20px;
                    background: linear-gradient(135deg, #bee3f8 0%, #90cdf4 100%);
                    border-radius: 20px;
                    color: #1a365d;
                    margin-bottom: 50px;
                  }

                  .screening-logo {
                    max-width: 200px;
                    height: auto;
                  }

                  .hero-section .title {
                    font-size: 2.5rem;
                    margin-bottom: 15px;
                    font-weight: 700;
                    color: #1a365d;
                  }

                  .hero-section .subtitle {
                    font-size: 1.3rem;
                    margin-bottom: 20px;
                    color: #1a365d;
                  }

                  .hero-section .hero-description {
                    font-size: 1.1rem;
                    max-width: 700px;
                    margin: 0 auto 30px;
                    color: #1a365d;
                  }

                  .diya-card-notice {
                    background: #fff;
                    border: 2px solid #1767c8;
                    border-radius: 12px;
                    padding: 20px;
                    max-width: 700px;
                    margin: 20px auto;
                    color: #000;
                    font-size: 1rem;
                    line-height: 1.6;
                  }

                  .diya-card-notice strong {
                    color: #e55711;
                  }

                  .content-section {
                    margin-bottom: 60px;
                  }

                  .section-title {
                    font-size: 2rem;
                    font-weight: 700;
                    margin-bottom: 25px;
                    color: #2d3748;
                  }

                  .section-intro {
                    font-size: 1.1rem;
                    color: #4a5568;
                    margin-bottom: 20px;
                  }

                  .section-content {
                    font-size: 1.05rem;
                    line-height: 1.8;
                    color: #4a5568;
                  }

                  .highlight-box {
                    background: #edf2f7;
                    border-left: 4px solid #4299e1;
                    padding: 20px;
                    margin: 20px 0;
                    border-radius: 8px;
                  }

                  .official-program-link {
                    display: inline-block;
                    margin: 5px 0 20px;
                    color: #1f6fb2;
                    font-weight: 700;
                    text-decoration: underline;
                  }

                  .official-program-link:hover {
                    color: #164f80;
                  }

                  .target-card {
                    background: white;
                    border: 2px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 30px;
                    height: 100%;
                    transition: all 0.3s ease;
                  }

                  .target-card:hover {
                    border-color: #4299e1;
                    box-shadow: 0 10px 30px rgba(66, 153, 225, 0.1);
                    transform: translateY(-5px);
                  }

                  .target-card h4 {
                    color: #2d3748;
                    font-weight: 600;
                    margin-bottom: 15px;
                  }

                  .steps-container {
                    max-width: 800px;
                    margin: 0 auto;
                  }

                  .step-item {
                    display: flex;
                    margin-bottom: 30px;
                    background: #fff;
                    align-items: flex-start;
                    padding: 10px;
                    border-radius: 10px;
                  }

                  .step-number {
                    width: 50px;
                    height: 50px;
                    background: #4299e1;
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    font-weight: 700;
                    flex-shrink: 0;
                    margin-right: 20px;
                  }

                  .step-content h4 {
                    color: #2d3748;
                    font-weight: 600;
                    margin-bottom: 10px;
                  }

                  .services-card {
                    background: #f7fafc;
                    border-radius: 12px;
                    padding: 25px;
                    height: 100%;
                  }

                  .services-card h4 {
                    color: #2d3748;
                    font-weight: 600;
                    margin-bottom: 20px;
                    padding-bottom: 15px;
                    border-bottom: 2px solid #4299e1;
                  }

                  .services-card ul {
                    list-style: none;
                    padding: 0;
                  }

                  .services-card li {
                    padding: 8px 0;
                    padding-left: 25px;
                    position: relative;
                  }

                  .services-card li:before {
                    content: "✓";
                    position: absolute;
                    left: 0;
                    color: #4299e1;
                    font-weight: bold;
                  }

                  .benefit-item {
                    display: flex;
                    align-items: flex-start;
                    gap: 10px;
                  }

                  .benefit-item i {
                    font-size: 1.2rem;
                    margin-top: 2px;
                  }

                  .faq-item {
                    background: #f7fafc;
                    border-radius: 12px;
                    padding: 25px;
                    margin-bottom: 20px;
                  }

                  .faq-item h4 {
                    color: #2d3748;
                    font-weight: 600;
                    margin-bottom: 15px;
                  }

                  .cta-section {
                    background: linear-gradient(135deg, #bee3f8 0%, #90cdf4 100%);
                    border-radius: 20px;
                    padding: 60px 40px;
                    color: #1a365d;
                  }

                  .cta-section h3 {
                    font-size: 2rem;
                    margin-bottom: 15px;
                    color: #1a365d;
                  }

                  .cta-section p {
                    font-size: 1.2rem;
                    margin-bottom: 30px;
                    color: #2c5282;
                  }

                  .links-list {
                    list-style: none;
                    padding: 0;
                  }

                  .links-list li {
                    margin-bottom: 15px;
                  }

                  .links-list a {
                    color: #4299e1;
                    text-decoration: none;
                    font-size: 1.1rem;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    transition: color 0.3s ease;
                  }

                  .links-list a:hover {
                    color: #2c5282;
                  }

                  @media (max-width: 768px) {
                    .hero-section .title {
                      font-size: 1.8rem;
                    }

                    .hero-section .subtitle {
                      font-size: 1.1rem;
                    }

                    .section-title {
                      font-size: 1.5rem;
                    }

                    .cta-section h3 {
                      font-size: 1.5rem;
                    }
                  }
                `}</style>

              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NationalScreeningPage;
